import React from "react";
import { Row } from "reactstrap";

import ScriptsTitle from "./ScriptsTitle";

export default function MenuButtons() {
  return (
    <div>
      <div className="p-3" style={{ height: "58px" }}>
        <Row>
          <ScriptsTitle />
        </Row>
      </div>
      <hr />
    </div>
  );
}
